import { LoginButton } from '../components/LoginButton';

export function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4">
      <LoginButton />
    </div>
  );
}
